import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconThumbsDown12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconThumbsDown12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m8.755 7.014-2.699 3.6c-.576.768-1.8.36-1.8-.6V7.03H2.502a1.5 1.5 0 0 1-1.386-2.075l1.257-3.031A1.5 1.5 0 0 1 3.758.999h5.998a1.5 1.5 0 0 1 1.5 1.5v3.02a1.5 1.5 0 0 1-1.51 1.5l-.949-.006-.04.001zm.501-.998.497.004a.5.5 0 0 0 .503-.5V2.499a.5.5 0 0 0-.5-.5h-.5zm-1-4.017H3.758a.5.5 0 0 0-.462.308L2.04 5.34a.5.5 0 0 0 .462.692h2.754v3.982l2.7-3.6.3-.4z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconThumbsDown12);
